import { getM8PartnerURL } from 'services/production/utils/getM8URL';
import { HTTPResponseError } from 'utils/errors';
import { appendFormDataWithObjectValues, customFetch } from 'utils/http';

type Params = {
  image: File;
  mimeType: string;
};

export const setPartnerAvatar = async (params: Params): Promise<void> => {
  const body = new FormData();

  appendFormDataWithObjectValues(body, params);

  const response = await customFetch(getM8PartnerURL('setPartnerAvatar'), {
    method: 'POST',
    body,
  });

  if (!response.ok) {
    throw new HTTPResponseError(response);
  }
};
